import { stylesheet } from 'typestyle';
import { colors } from '../../assets/styles';

const styles = stylesheet({
  footerWrapper: {
    backgroundColor: colors.darkBlueBackground,
    flexDirection: 'row',
    alignItems: 'center',
    display: 'flex',
    width: '100%',
    height: 'auto',
    padding: '30px 15px',
    justifyContent: 'center',
  },
  footer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  }
});

export default styles;
